import { CloseOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import MaterialDetailsSidebar from "./material-details-sidebar";
import { MaterialDetailsData } from "./types";

function MaterialDetailsMobileDrawer({
  open,
  onClose,
  data
}: {
  open: boolean;
  onClose: () => void;
  data: MaterialDetailsData;
}) {
  return (
    <Drawer
      placement="bottom"
      open={open}
      onClose={onClose}
      closable={false}
      destroyOnHidden
      data-testid="material-details-mobile-drawer"
      title={
        <div className="w-full max-w-full flex justify-between items-center gap-2 overflow-hidden">
          <div className="grow overflow-hidden">
            <div className="font-semibold truncate text-sm text-color-1">
              Material Details
            </div>
          </div>
          <button
            type="button"
            className="ciq-icon-button"
            onClick={onClose}
            data-testid="material-details-mobile-drawer-close"
          >
            <CloseOutlined />
          </button>
        </div>
      }
    >
      <MaterialDetailsSidebar
        data={data}
        showTitle={false}
        className="w-full lg:w-full px-0 py-0"
      />
    </Drawer>
  );
}

export default MaterialDetailsMobileDrawer;
